export const environment = {
  production: false,
  environment: "dev",
  eventManagmentApiBaseUrl: '/api',
  emsUrl: 'https://event-management-api.dev-apps.enelx.net',
  baseUrl: 'https://api.eps.dev-apps.enelx.net/v1',
  globalNavUrl: 'https://global-nav.dev-svcs.enelx.net/api/v1',
  cdn: 'https://cdn.dev-apps.enelx.net',
  openAmCookieDomain: '.enelx.net',
  defaults: {
    brand: 'ENELX',
    locale: 'en-us',
  },
};
